<template>
    <div class="printManagementDialog">
        <el-dialog
            title="选择发票"
            :visible.sync="invoiceDialogVisible"
            width="800px" class="invoiceTitleDialogBox">
            <div class="invoiceTitleDialog">
                <div class="invoice_top">
                    <el-button type="text" @click="addInvoice" class="invoice_add">新增发票</el-button>
                    <el-tabs v-model="activeName" @tab-click="searchInvoiceInfo">
                        <el-tab-pane label="电子发票" name="DZFP"></el-tab-pane>
                        <el-tab-pane label="纸质发票" name="ZZFP"></el-tab-pane>
                    </el-tabs>
                </div>

                <div class="electronicInvoice" v-if="activeName === 'DZFP'">
                    <h3>请选择发票</h3>
                    <div class="invoiceList">
                        <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                            <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                         @change="invoiceCheckChange(item)"></el-checkbox>
                            <div>
                                <div class="type">
                                    {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}} ({{item.billType=='ENTERPRISE'?'企业':'个人'}})
                                </div>
                                <div class="name">{{item.title}}</div>
                                <div class="num" v-if="item.code">{{item.code}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="electronicInvoice" v-if="activeName === 'ZZFP'">
                    <h3>请选择发票</h3>
                    <div class="invoiceList">
                        <div class="invoiceItem" v-for="(item,index) in electronicInvoiceList" :key="index">
                            <el-checkbox v-model="item.checked" class="invoiceCheckBox"
                                         @change="invoiceCheckChange(item)"></el-checkbox>
                            <div>
                                <div class="type">
                                    {{item.invoiceType=='SPECIAL'?'专用发票':'普通发票'}}
                                </div>
                                <div class="name">{{item.title}}</div>
                                <div class="num" v-if="item.code">{{item.code}}</div>
                            </div>
                        </div>
                    </div>
                    <h3>请选择收票地址</h3>
                    <div class="addressList">
                        <div :class="item.checked?'active addressItem':'addressItem'" v-for="(item,index) in invoiceAddressList" :key="index">
                            <el-checkbox class="checkBox" v-model="item.checked" @change="invoiceAddressChecked(item)"></el-checkbox>
                            <div class="name">{{item.receiverName}} <el-button v-if="item.checked" type="text" icon="el-icon-edit" style="padding: 0;position: relative;z-index: 9;" @click="toEditAddress(item)"></el-button></div>
                            <div class="tel">{{item.mobile}}</div>
                            <div class="address">{{ item.province }}{{ item.city }}{{ item.district }}{{ item.areaInfo }}</div>
                            <img v-if="item.checked" src="@/assets/addressBorder.png" class="addressBorder">
                        </div>
                    </div>
                </div>
                <div class="buttonGroup">
                    <el-button @click="invoiceDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="selectInvoice">选择</el-button>
                </div>
            </div>
        </el-dialog>
        <invoice-dialog ref="dialogRef"></invoice-dialog>
    </div>
</template>

<script>
    import {getAddressList, invoiceTitleList} from "../../../utils/interface";
    import {getIssueInvoiceByUuid,saveIssueInvoiceByUuid} from "../../../utils/issueInvoice";
    import invoiceDialog from "../../service/invoiceDialog";

    export default {
        name: "issueInvoiceDialog",
        data() {
            return {
                invoiceDialogVisible: false,
                activeName:"DZFP",
                invoiceType:"NORMAL",
                invoiceUuid:"",
                payeeUuid:"",
                electronicInvoiceList:[],
                invoiceAddressList:[],
                invoiceForm:{},
                uuid:"",
            };
        },
        components: {
            invoiceDialog
        },
        methods: {
            init(params) {
                this.reset();
                this.invoiceDialogVisible = true;
                this.invoiceForm = params;
                // 查询发票地址，如果保存过发票地址则回显
                this.getInvoiceList();
                // 查询接收地址，如果存在地址则回显
                this.getAddressList();
                if(this.invoiceForm.uuid){
                    getIssueInvoiceByUuid(this.invoiceForm.uuid).then((res)=>{
                        this.invoiceForm = res;
                    });
                }
            },
            reset(){
                this.activeName="DZFP";
                this.invoiceType="NORMAL";
                this.invoiceUuid="";
                this.payeeUuid="";
                this.electronicInvoiceList=[];
                this.invoiceAddressList=[];
                this.invoiceForm={};
                this.uuid="";
            },
            searchInvoiceInfo(){
                if(this.activeName==="DZFP"){
                    this.invoiceType = "NORMAL";
                }else if(this.activeName==="ZZFP"){
                    this.invoiceType = "";
                }
                this.electronicInvoiceList = [];
                this.getInvoiceList();
            },
            getInvoiceList(){
                let params = {
                    invoiceType:this.invoiceType
                };
                invoiceTitleList(params).then((res)=>{
                    if(res&&res.length>0){
                        res.map(item=>{
                            if(this.invoiceUuid!=null) {
                                if (item.uuid == this.invoiceUuid) {
                                    item.checked = true;
                                } else {
                                    item.checked = false;
                                }
                            }else{
                                if (item.isDefault) {
                                    item.checked = true;
                                } else {
                                    item.checked = false;
                                }
                            }
                        });
                    }
                    this.electronicInvoiceList = res;
                });
            },
            getAddressList(){
                getAddressList().then((res)=>{
                    res.data.map(items => {
                        if(this.payeeUuid!=null){
                            if(items.uuid == this.payeeUuid){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }else{
                            if(items.defaultVal==1){
                                items.checked = true;
                            }else {
                                items.checked = false;
                            }
                        }
                    });
                    this.invoiceAddressList = res.data;
                });
            },
            // 选择电子发票复选框
            invoiceCheckChange(val) {
                this.electronicInvoiceList.map(item => {
                    if (val.uuid !== item.uuid) {
                        item.checked = false
                    } else {
                        item.checked = val.checked
                    }
                })
            },
            invoiceAddressChecked(val) {
                this.invoiceAddressList.map(item => {
                    if (item.uuid === val.uuid) {
                        item.checked = val.checked
                    } else {
                        item.checked = false
                    }
                })
            },
            //
            selectInvoice() {
                let flagBoo = true;

                this.invoiceForm.issueType = this.activeName;

                console.log("1="+JSON.stringify(this.electronicInvoiceList))
                if (this.activeName === 'DZFP') {
                    let electronicInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    if (electronicInvoiceSelected.length <= 0) {
                        flagBoo = false;
                        this.$message.warning('请选择发票!')
                    } else {
                        // 电子发票
                        // 查询企业还是个人
                        this.invoiceForm.uuid = this.uuid;
                        this.invoiceForm.invoiceType = "NORMAL";
                        this.invoiceForm.invoiceUuid = electronicInvoiceSelected[0].uuid;
                        this.invoiceForm.invoiceStatus = "EXAMINE";
                    }
                } else {
                    let paperInvoiceSelected = this.electronicInvoiceList.filter(item => {
                        return item.checked === true
                    });
                    let addressSelected = this.invoiceAddressList.filter(item => {
                        return item.checked === true
                    });
                    if (paperInvoiceSelected.length <= 0) {
                        flagBoo = false;
                        this.$message.warning('请选择发票!')
                    } else if (addressSelected.length <= 0) {
                        this.$message.warning('请选择收票地址!')
                        flagBoo = false;
                    } else {
                        this.invoiceForm.uuid = this.uuid;
                        this.invoiceForm.invoiceType = paperInvoiceSelected[0].invoiceType;
                        this.invoiceForm.invoiceUuid = paperInvoiceSelected[0].uuid;
                        this.invoiceForm.payeeUuid = addressSelected[0].uuid;
                        this.invoiceForm.invoiceStatus = "EXAMINE";
                    }
                }

                if(flagBoo){
                    saveIssueInvoiceByUuid(this.invoiceForm).then((res)=>{
                        if(res.success){
                            this.$message.success('申请成功!');
                            this.invoiceDialogVisible = false;
                            this.$parent.searchInfo();
                        }
                    });
                }
            },
            addInvoice(){
                this.$refs.dialogRef.init("add","","order");
                console.log('222', );
            }
        },
    };
</script>

<style scoped lang="less">
    .printManagementDialog {
        padding: 94px 20px 20px;
        .orderListTabs {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7;
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #e4e7ed;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7;
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
                margin-bottom: 22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom: 22px;
            }
        }

        .orderListTable {
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 16px;

                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 5px;
                                display: block;
                            }

                            img {
                                display: block;
                                padding-right: 5px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            display: flex;
                            align-items: center;

                            img {
                                display: block;
                                width: 147px;
                                height: 83px;
                                border-radius: 10px;
                                margin-right: 30px;
                            }

                            .infoContent {
                                .infoName {
                                    font-size: 14px;
                                    color: #000000;
                                    padding-bottom: 10px;
                                }

                                .infoOther {
                                    font-size: 13px;
                                    color: #999999;
                                    padding-bottom: 8px;
                                }
                            }
                        }

                        .arguments {
                            padding: 20px;
                        }

                        .argumentsName {
                            padding-bottom: 8px;
                        }
                        .payment {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status {
                            font-size: 14px;
                        }
                        .operationBtn {
                            display: block;
                            color: #0c75d3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                        .operationBtnMoney {
                            color: #0c75d3;
                            padding: 6px 20px;
                            border: 1px solid #0c75d3;
                            border-radius: 6px;
                        }
                    }
                }
            }

            .name {
                flex: 1;
                border-right: 1px solid #efefef;
            }

            .price {
                width: 246px;
                text-align: center;
            }

            .num {
                width: 95px;
                text-align: center;
            }

            .arguments {
                width: 294px;
            }

            .payment {
                width: 242px;
                text-align: center;
            }

            .status {
                width: 200px;
                text-align: center;
            }

            .operation {
                width: 200px;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
        .electronicInvoice {
            h3 {
                padding-bottom: 15px;
                color: #000;
                font-size: 15px;
            }

            .invoiceList {
                .invoiceItem {
                    border: 1px solid #ddd;
                    padding: 10px 50px 10px 15px;
                    border-radius: 10px;
                    margin-bottom: 15px;
                    display: flex;
                    align-items: center;
                    position: relative;
                    display: flex;
                    align-items: center;

                    .invoiceCheckBox {
                        padding-right: 15px;
                    }

                    .type {
                        font-size: 12px;
                        color: #666;
                        padding-bottom: 5px;
                    }

                    .name {
                        font-size: 15px;
                        color: #000;
                        padding-bottom: 5px;
                    }

                    .num {
                        font-size: 12px;
                        color: #333;
                    }

                    .edit {
                        position: absolute;
                        right: 15px;
                        top: 50%;
                        margin-top: -10px;
                        padding: 0;
                    }
                }
            }

            .emailList {
                padding: 0 15px 15px;

                /deep/ .el-radio {
                    margin-bottom: 15px;
                    display: block;
                    margin-right: 0;
                }
            }
        }
        .addressList{
            display: flex;
            flex-wrap: wrap;
            .addressItem{
                padding: 14px 22px;
                margin-bottom: 24px;
                margin-right: 30px;
                position: relative;
                width: 270px;
                border-radius: 8px;
                border: 2px dashed #E3E3E3;
                font-size: 14px;
                .addressBorder{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                }
                &.active{
                    border: 2px dashed #fff;
                }
                &:nth-of-type(4n){
                    margin-right: 0;
                }
                .checkBox{
                    position: absolute;
                    right: 22px;
                    top: 14px;
                }
                .name{
                    color: #000;
                }
                .tel{
                    color: rgba(51, 51, 51, 0.85);
                    padding: 6px 0;
                }
                .address{
                    color: rgba(51, 51, 51, 0.85);
                    line-height: 22px;
                }
            }
            .addItem{
                text-align: center;
                cursor: pointer;
                color: #666;
                &:hover{
                    border: 2px dashed #1890FF;
                }
                .icon{
                    font-size: 30px;
                }
                .addName{
                    font-size: 14px;
                    padding-top: 5px;
                }
            }
        }
    }
    .invoiceTitleDialog {
        .invoice_top {
            position: relative;
            .invoice_add {
                position: absolute;
                right: 0;
                z-index: 99;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/issueInvoiceDialog.vue